import React, { memo } from 'react';
import { Blok } from '../../../interfaces/Blok.interface';
import { StoryblokRichtext } from 'storyblok-rich-text-react-renderer';
import SubmitFormSectionLegalCopy from './SubmitFormSectionLegalCopy';
import SubmitFormSectionButtons from './SubmitFormSectionButtons';
import { ProductType } from '../../../services/quote.interfaces';

export interface SubmitFormSectionBlokProps extends Blok {
  legal_copy: StoryblokRichtext;
  selectedProductType: ProductType;
}

interface SubmitFormSectionProps {
  blok: SubmitFormSectionBlokProps;
}

const SubmitFormSection: React.FC<SubmitFormSectionProps> = ({ blok }) => {
  const { legal_copy, selectedProductType } = blok;

  return (
    <section>
      {legal_copy && <SubmitFormSectionLegalCopy legal_copy={legal_copy} />}
      <SubmitFormSectionButtons selectedProductType={selectedProductType} />
    </section>
  );
};

export default memo(SubmitFormSection);
